import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { take } from 'rxjs';

import { UserGetFailure, UserGetRequest, UserGetSuccess } from '../../store/user/user.actions';
import { User } from '../../store/user/user.models';
import { selectUser } from '../../store/user/user.selectors';

@Component({
  selector: 'app-entry-redirect',
  standalone: true,
  imports: [CommonModule],
  template: `<section class="entry-redirect">Loading your workspace...</section>`,
  styles: [`.entry-redirect{min-height:100vh;display:grid;place-items:center;color:#334155;font:600 1rem/1.4 system-ui,sans-serif;}`],
})
export class AppEntryRedirect {
  private readonly store = inject(Store);
  private readonly router = inject(Router);
  private readonly actions$ = inject(Actions);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.store.select(selectUser).pipe(take(1), takeUntilDestroyed(this.destroyRef)).subscribe((user) => {
      if (user) {
        this.redirect(user);
        return;
      }

      this.store.dispatch(UserGetRequest());
      this.actions$.pipe(ofType(UserGetSuccess, UserGetFailure), take(1)).subscribe((action) => {
        if ('user' in action) {
          this.redirect(action.user);
          return;
        }

        void this.router.navigate(['/auth/login']);
      });
    });
  }

  private redirect(user: User): void {
    const role = (user.role ?? '').trim().toLowerCase();
    if (role === 'superadmin' || role === 'super_admin') {
      void this.router.navigate(['/platform/dashboard']);
      return;
    }

    void this.router.navigate(['/home/chat']);
  }
}
